const ujs = require("@rails/ujs")
;(ujs.default || ujs).start?.()
const turbolinks = require("turbolinks")
;(turbolinks.default || turbolinks).start?.()
const activestorage = require("@rails/activestorage")
;(activestorage.default || activestorage).start?.()
require("channels")

import "../controllers/questionnaire_stepper_controller"
import * as echarts from "echarts"
if (typeof window !== "undefined") window.echarts = echarts
import "controllers"

import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"

const application = Application.start()
const context = require.context("../controllers", true, /\.js$/)
const filteredContext = (key) => context(key)
filteredContext.keys = () =>
  context.keys().filter((key) => !key.includes("questionnaire_stepper_controller"))
application.load(definitionsFromContext(filteredContext))
